export default "__VITE_ASSET__Bwzw3rTV__"